/* Native GET forms own filtering, sorting and history. No catalog fetching or browser-side data store. */
(() => {
  function validate(form) {
    let valid = true;
    form.querySelectorAll('[data-price-range]').forEach(range => {
      const min = range.querySelector('[data-price-min]'), max = range.querySelector('[data-price-max]');
      const reversed = min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value);
      max.setCustomValidity(reversed ? form.dataset.rangeError : '');
      if (reversed) valid = false;
    });
    return valid;
  }
  document.addEventListener('input', event => {
    const form = event.target.closest('[data-catalog-form]');
    if (form) validate(form);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-catalog-form]');
    if (form && !validate(form)) { event.preventDefault(); form.reportValidity(); }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-catalog-sort]')) return;
    const form = event.target.form;
    if (validate(form) && form.reportValidity()) form.requestSubmit();
  });
})();

